import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

export default function Educational() {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <div className={`${themeClass.bgColor} ${themeClass.baseText} min-h-screen`}>

    <div className={`min-h-screen px-6 py-12 ${themeClass.bgColor} ${themeClass.baseText}`}>
      <Helmet>
        <title>Educational Browser Games for Kids | BrowserArena</title>
        <meta
          name="description"
          content="Discover fun and interactive educational browser games for kids that enhance learning in math, reading, problem-solving, and more."
        />
        <meta
          name="keywords"
          content="educational games for kids, browser games for learning, free online educational games"
        />
        <link rel="canonical" href="https://browserarena.com/educations" />
        <meta property="og:title" content="Educational Browser Games for Kids | BrowserArena" />
        <meta property="og:description" content="Fun educational browser games for kids — learn math, reading, problem-solving and more through play." />
        <meta property="og:url" content="https://browserarena.com/educations" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className={`max-w-4xl mx-auto rounded-2xl border ${themeClass.borderColor} ${themeClass.overlayBg} shadow-xl backdrop-blur-lg p-8`}>
        <h1 className={`text-4xl font-bold mb-6 tracking-wide ${themeClass.titleColor}`}>
          Educational Browser Games for Kids
        </h1>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Browser-based educational games have become an essential tool in modern learning environments. Designed to be both fun and informative, these games help children improve skills in math, reading, problem-solving, and more—without feeling like a chore.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          These games seamlessly blend gameplay with learning objectives. Puzzle games strengthen logic, word games expand vocabulary, and science or geography games spark curiosity about the world.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Trusted by parents and teachers, our games are accessible on desktops, tablets, and mobile devices—perfect for classrooms or home learning.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          At <strong>BrowserArena</strong>, we handpick educational games that are safe, visually engaging, and aligned with real academic goals. From spelling bees to math puzzles, we aim to make learning playful.
        </p>

        <div className="mt-8 text-center">
          <p className={`text-base mb-4 ${themeClass.overlayText}`}>
            Learn more about{" "}
            <Link to="/about-browser-games" className={`${themeClass.hoverText} underline`}>
              browser games
            </Link>{" "}
            or explore our{" "}
            <Link to="/html5-games" className={`${themeClass.hoverText} underline`}>
              HTML5 games
            </Link>{" "}
            collection now.
          </p>

          <p className={`text-sm italic ${themeClass.overlayText}`}>
            🧠 Coming Soon: Dedicated Educational Games Section
          </p>
        </div>
      </div>
    </div>
    </div>
  );
}
